
      var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGuestIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 120,
  viewBox: "0 0 80 80",
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 27.136,
  cy: 33.75,
  r: 16.25,
  stroke: "#000",
  strokeWidth: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.817 61.111a1 1 0 0 0 1.636 1.15l-.818-.575-.818-.575ZM48.82 62.26a1 1 0 0 0 1.636-1.15l-.818.575-.818.575Zm-44.184-.573.818.575A26.505 26.505 0 0 1 27.136 51v-2c-9.281 0-17.981 4.519-23.319 12.111l.818.576ZM27.135 50v1c8.63 0 16.72 4.2 21.684 11.26l.818-.575.818-.575A28.505 28.505 0 0 0 27.135 49v1Z",
  fill: "#000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M47.931 17.143a1 1 0 0 0 .543 1.925l-.271-.963-.272-.962Zm17.038 6.052-.76.65.76-.65Zm3.549 7.226-.98.204.98-.204Zm-1.149 10.131.908.419-.908-.419ZM52.612 49a1 1 0 0 0 0 2v-2Zm0 0a1 1 0 0 0 0 2v-2Zm21.681 13.26a1 1 0 0 0 1.637-1.15l-.818.575-.819.574Zm-26.09-44.155.27.963a15.252 15.252 0 0 1 15.736 4.776l.76-.649.76-.65a17.252 17.252 0 0 0-17.798-5.402l.272.962Zm16.766 5.09-.76.65a15.232 15.232 0 0 1 3.33 6.78l.979-.204.978-.205a17.232 17.232 0 0 0-3.766-7.67l-.76.649Zm3.549 7.226-.98.204c.658 3.142.32 6.476-1.077 9.509l.908.418.908.419a17.242 17.242 0 0 0 1.22-10.755l-.98.205Zm-1.149 10.131-.908-.418A15.252 15.252 0 0 1 52.61 49v1l.001 1a17.252 17.252 0 0 0 15.665-10.03l-.908-.418ZM52.612 50v1a26.467 26.467 0 0 1 21.681 11.26l.819-.575.818-.575A28.467 28.467 0 0 0 52.611 49v1Z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"120\" height=\"120\" viewBox=\"0 0 80 80\" fill=\"none\">\r\n  <circle cx=\"27.1362\" cy=\"33.75\" r=\"16.25\" stroke=\"#000000\" stroke-width=\"2\"/>\r\n  <path d=\"M3.81719 61.1113C3.49956 61.5632 3.60833 62.1869 4.06013 62.5045C4.51194 62.8222 5.13569 62.7134 5.45332 62.2616L4.63525 61.6865L3.81719 61.1113ZM48.8186 62.2599C49.1363 62.7117 49.7601 62.8204 50.2118 62.5028C50.6636 62.1851 50.7724 61.5613 50.4547 61.1096L49.6367 61.6847L48.8186 62.2599ZM4.63525 61.6865L5.45332 62.2616C10.4165 55.2019 18.5058 51.0003 27.1356 51L27.1355 50L27.1355 49C17.8546 49.0004 9.15484 53.5189 3.81719 61.1113L4.63525 61.6865ZM27.1355 50L27.1356 51C35.7653 50.9997 43.8549 55.2006 48.8186 62.2599L49.6367 61.6847L50.4547 61.1096C45.1165 53.5175 36.4164 48.9996 27.1355 49L27.1355 50Z\" fill=\"#000000\"/>\r\n  <path d=\"M47.9314 17.1427C47.3999 17.2925 47.0903 17.8449 47.2401 18.3765C47.3899 18.908 47.9422 19.2176 48.4738 19.0678L48.2026 18.1053L47.9314 17.1427ZM64.9694 23.195L64.2089 23.8444L64.9694 23.195ZM68.5177 30.4208L67.5388 30.6254L68.5177 30.4208ZM67.369 40.5522L68.2771 40.9709L67.369 40.5522ZM52.6118 48.9999C52.0595 49 51.6118 49.4478 51.6119 50.0001C51.6119 50.5523 52.0597 51 52.612 50.9999L52.6119 49.9999L52.6118 48.9999ZM52.6112 48.9999C52.0589 49.0003 51.6115 49.4484 51.6119 50.0007C51.6123 50.553 52.0603 51.0003 52.6126 50.9999L52.6119 49.9999L52.6112 48.9999ZM74.2935 62.2593C74.6109 62.7113 75.2346 62.8205 75.6866 62.5031C76.1386 62.1858 76.2478 61.5621 75.9304 61.1101L75.112 61.6847L74.2935 62.2593ZM48.2026 18.1053L48.4738 19.0678C54.2016 17.454 60.3448 19.3189 64.2089 23.8444L64.9694 23.195L65.7299 22.5457C61.3591 17.4267 54.4103 15.3173 47.9314 17.1427L48.2026 18.1053ZM64.9694 23.195L64.2089 23.8444C65.9046 25.8303 67.0253 28.1689 67.5388 30.6254L68.5177 30.4208L69.4965 30.2162C68.9157 27.4377 67.6477 24.7917 65.7299 22.5457L64.9694 23.195ZM68.5177 30.4208L67.5388 30.6254C68.1957 33.7675 67.8589 37.1008 66.4608 40.1336L67.369 40.5522L68.2771 40.9709C69.8586 37.5404 70.2393 33.7692 69.4965 30.2162L68.5177 30.4208ZM67.369 40.5522L66.4608 40.1336C63.9694 45.5377 58.5625 48.9993 52.6118 48.9999L52.6119 49.9999L52.612 50.9999C59.3431 50.9992 65.459 47.0836 68.2771 40.9709L67.369 40.5522ZM52.6119 49.9999L52.6126 50.9999C61.2431 50.9937 69.3345 55.1958 74.2935 62.2593L75.112 61.6847L75.9304 61.1101C70.5967 53.5128 61.8938 48.9932 52.6112 48.9999L52.6119 49.9999Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/guest-icon.22b98838b4428c613a8ae07b037ca48b.svg"),
        {
          React: SvgGuestIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      